
const config = 'https://api.budandtulips.com'
// latest version
export default config